import React, { useEffect, useRef, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import {
    getFprContentList,
    getFprDecesInfoDecesList,
    getFprDecesIntervenantList,
    getFprSymbolList,
    getIntroductionTextList,
    getRemerciementTextList,
    saveFprData,
} from "../../api/pro/fprReq";
import TiptapForm from "../../components/common/input-layout/tiptap/TiptapForm";
import FormButtons from "../../components/common/FormButtons";
import {
    capitalize, checkRequiredFields, getErrorListFromValidation, processFprTextEquivalences, adaptFprGenderText,
    replaceHomeAddress as replaceHomeAddressUtil, replaceHomeRecAddress as replaceHomeRecAddressUtil,
    formatFprAddress, getFprEventDefaultContent
} from "../../helper/tools";
import useDeceased from "../../hooks/useDeceased";
import { getDeceasedInfos } from "../../api/pro/deceasedReq";
import { getEventList, getEventListInfos } from "../../api/pro/eventReq";

export default function FormEditFprContent({ typeFpr, setShowModal, contentType, apiFprDataSaved, fprDataSaved, fprDataContentSaved }) {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const [values, setValues] = useState(fprDataContentSaved);
    const IMG_FOLDER = process.env.REACT_APP_LOCAL_ASSETS_BASE_URL;
    const [fprDecesContentList, setFprDecesContentList] = useState();
    const [fprIntervenantList, setFprIntervenantList] = useState();
    const [fprFilteredList, setFprFilteredList] = useState();
    const [fprIntroductionList, setFprIntroductionList] = useState();
    const [fprRemerciementList, setFprRemerciementList] = useState();
    const [keyword, setKeyword] = useState();
    const [selectedIntervenantText, setSelectedIntervenantText] = useState('');
    const [keywordList, setKeywordList] = useState();
    const symboleInputRef = useRef();
    const epitapheInputRef = useRef();
    const [type, setType] = useState();
    const [fprInfosDecesList, setFprInfosDecesList] = useState();
    const [filteredKeywordList, setFilteredKeywordList] = useState();
    const [fprSymbolList, setFprSymbolList] = useState();
    const { deceasedInfos, setDeceasedInfos, eventList, setEventList } = useDeceased()
    const [deceasedEventInfos, setDeceasedEventInfos] = useState();
    const [renderKey, setRenderKey] = useState(0);
    const [selectedFormule, setSelectedFormule] = useState(fprDataContentSaved?.['form-modalEpitaphe']);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const apiDeceasedEventInfos = async () => {
        const response = await getEventListInfos(token, id)
        if (response) {
            setDeceasedEventInfos(response)
        }
    }

    const replaceHomeAddress = (place) => replaceHomeAddressUtil(place, deceasedInfos);
    const replaceHomeRecAddress = (place) => replaceHomeRecAddressUtil(place);
    const formatAddress = (address) => formatFprAddress(address);
    const adaptGenderText = (text) => adaptFprGenderText(text, deceasedInfos);
    const getDefaultValue = (contentType) => getFprEventDefaultContent(contentType, { eventList, deceasedInfos, deceasedEventInfos });
    const processEquivalences = (list) => processFprTextEquivalences(list, deceasedInfos);

    const apiEventList = async () => {
        const response = await getEventList(token, id)
        setEventList(Array.isArray(response) ? response : [])
    }

    useEffect(() => {
        if (!deceasedInfos) {
            apiDeceasedInfos()
        }
    }, [id, deceasedInfos]);

    useEffect(() => {
        if (eventList?.length < 1) {
            apiEventList()
        }
        if (!deceasedEventInfos) {
            apiDeceasedEventInfos()
        }
    }, [id, eventList, deceasedEventInfos]);

    const apiDeceasedInfos = async () => {
        const response = await getDeceasedInfos(token, id)
        if (response) {
            setDeceasedInfos(response)
        }
    }

    const apiFprIntervenantsList = async () => {
        const response = await getFprDecesIntervenantList(token, id)
        setFprIntervenantList(response)
    }

    const apiFprDecesInfoDecesList = async () => {
        const response = await getFprDecesInfoDecesList(token, id)
        setFprInfosDecesList(response)
    }

    const apiIntroductionTextList = async () => {
        const response = await getIntroductionTextList(token, 4, 3)
        setFprIntroductionList(processEquivalences(response))
    }

    const apiRemerciementTextList = async () => {
        const response = await getRemerciementTextList(token, 0, 2, id)
        setFprRemerciementList(response)
    }

    const apiFprDecesContentList = async () => {
        if (contentType !== "Symboles" && type) {
            const response = await getFprContentList(token, type)
            setFprDecesContentList(response)
            if (contentType === 'Epitaphes') {
                setFprFilteredList(processEquivalences(response))
            }
        }
        if (contentType === "Symboles") {
            const response = await getFprSymbolList(token)
            setFprSymbolList(response)
        }
    }

    useEffect(() => {
        if (fprDecesContentList) {
            if (contentType === 'Epitaphes') {
                const allFilteredKeywords = new Set();
                fprDecesContentList.forEach((item) => {
                    item.keyword?.forEach((keyword) => {
                        allFilteredKeywords.add(keyword);
                    });
                });
                setKeywordList(Array.from(allFilteredKeywords).sort());

                if (!fprDataContentSaved?.['form-modalEpitaphe']) {
                    setTimeout(() => setIsInitialLoad(false), 100);
                }
            }
        }
    }, [fprDecesContentList, contentType, fprDataContentSaved]);

    useEffect(() => {
        if (fprSymbolList) {
            let kList = [];
            for (let symbol of fprSymbolList) {
                if (!kList.includes(symbol['keyword']))
                    kList.push(symbol['keyword'])
            }
            setKeywordList(kList)
            if (contentType === 'Symboles') {
                if (values?.content) {
                    const currentSymbol = fprSymbolList.find(s => values.content === s.url || values.content.endsWith('/' + s.url));
                    if (currentSymbol && currentSymbol.keyword) {
                        setKeyword(currentSymbol.keyword);
                        setFprFilteredList(fprSymbolList.filter(s => s.keyword === currentSymbol.keyword));
                    } else {
                        setFprFilteredList(fprSymbolList)
                    }
                } else {
                    setFprFilteredList(fprSymbolList)
                }
            }
        }
    }, [fprSymbolList, contentType, values?.content]);

    const onChange = (e) => {
        setValues(prev => ({ ...prev, content: e }))
    }

    useEffect(() => {
        if (selectedFormule) {
            setValues(prev => ({ ...prev, content: selectedFormule }))
        }
    }, [selectedFormule]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return
        }

        let body = {
            deceasedId: id,
            typeFpr: typeFpr,
            content: values?.content,
            contentType: contentType.toLowerCase()
        }


        await saveFprData(token, body)
            .then((response) => {
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiFprDataSaved()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const onChangeKeyword = (e) => {
        const val = e.target.value;
        setKeyword(val)
        setIsInitialLoad(false);
        if (val === "default") {
            if (contentType === 'Symboles') {
                setFprFilteredList(fprSymbolList)
            } else {
                setFprFilteredList(processEquivalences(fprDecesContentList))
            }
            return
        }
        if (fprDecesContentList) {
            let filteredList = fprDecesContentList?.filter(item => item['keyword'].includes(val))
            filteredList = processEquivalences(filteredList);
            setFprFilteredList(filteredList)
        }
        if (fprSymbolList) {
            let filteredList = fprSymbolList?.filter(item => item['keyword'].includes(val))
            setFprFilteredList(filteredList)
        }
    }

    useEffect(() => {
        if (fprFilteredList && fprFilteredList.length > 0) {
            if (isInitialLoad && contentType === 'Epitaphes' && fprDataContentSaved?.['form-modalEpitaphe']) {
                return;
            }
            setSelectedFormule(fprFilteredList[0]['text'] || '');
        }
    }, [fprFilteredList, contentType, fprDataContentSaved, isInitialLoad]);

    const handleRemoveModal = () => {
        setShowModal(false)
    }

    const convertTextToHTML = (text) => {
        if (!text) return '';
        if (text.includes('<p>')) return text;
        let normalizedText = text.replace(/<br\s*\/?>/gi, '\n');
        normalizedText = normalizedText.replace(/<[^>]+>/g, '');
        const lines = normalizedText.split('\n');
        if (lines.length === 0) return '<p></p>';

        return lines.map(line => {
            const content = line.trim().length > 0 ? line.trim() : '<br>';
            return `<p>${content}</p>`;
        }).join('');
    };

    const linesToHTML = (lines) => {
        if (!lines || lines.length === 0) return '<p></p>';

        return lines.map(line => {
            const content = (line && line.trim().length > 0) ? line.trim() : '<br>';
            return `<p>${content}</p>`;
        }).join('');
    };

    useEffect(() => {
        apiFprIntervenantsList()
        apiFprDecesInfoDecesList()
    }, [id]);

    const onChangeSymbol = (symbol) => {
        setValues(prev => ({ ...prev, content: symbol }));
        setRenderKey(prev => prev + 1);
    }

    useEffect(() => {
        if (contentType) {
            if (contentType === 'Epitaphes') {
                setType(1)
            } else if (contentType === 'Symboles') {
                setType(2)
            } else if (contentType === 'Formule d\'introduction') {
                setType(4)
            } else if (contentType === 'Information décès') {
                setType(6)
            }
        }
    }, [contentType]);

    const lastInitializedRef = useRef(null);

    useEffect(() => {
        // Ne (ré)initialiser la sélection courante qu'au premier chargement de cette rubrique, ou
        // dès que deceasedEventInfos arrive (nécessaire pour calculer les valeurs par défaut des
        // rubriques liées aux événements). Sans ce garde-fou, un simple re-rendu déclenché par un
        // contexte partagé sans rapport (eventList/deceasedInfos rafraîchis ailleurs) réexécutait
        // cet effet et écrasait une sélection en cours (ex: clic sur une autre épitaphe) avec
        // l'ancienne valeur enregistrée.
        const initKey = `${contentType}-${!!deceasedEventInfos}`;
        if (lastInitializedRef.current === initKey) {
            return;
        }
        lastInitializedRef.current = initKey;

        let initialValue = '';

        if (contentType === 'Epitaphes') {
            initialValue = fprDataContentSaved?.['form-modalEpitaphe'] || '';
            if (fprDataContentSaved?.['form-modalEpitaphe']) {
                setSelectedFormule(fprDataContentSaved?.['form-modalEpitaphe']);
                setIsInitialLoad(true);
            } else {
                setIsInitialLoad(false);
            }
        } else if (contentType === 'Symboles') {
            initialValue = fprDataContentSaved?.['form-symbole'] || '';
        } else if (contentType === 'Intervenants') {
            initialValue = fprDataContentSaved?.['form-modalIntervenant'] || '';

            if (initialValue && !initialValue.includes('<p>')) {
                initialValue = convertTextToHTML(initialValue);
            }

            setSelectedIntervenantText('default');
        } else if (contentType === 'Formule d\'introduction') {
            initialValue = fprDataContentSaved?.['form-modalIntro'] || '';
        } else if (contentType === 'Information décès') {
            initialValue = fprDataSaved?.['form-modalInfoDecease'] || '';
        } else if (contentType === 'Information cérémonie') {
            initialValue = fprDataContentSaved?.['form-modalInfoCeremoy'] || getDefaultValue('Information cérémonie');
            if (initialValue && !initialValue.includes('<p>')) {
                initialValue = convertTextToHTML(initialValue);
            }
        } else if (contentType === 'Information recueillement') {
            initialValue = fprDataContentSaved?.['form-modalInfoReceuillement'] || getDefaultValue('Information recueillement');
            if (initialValue && !initialValue.includes('<p>')) {
                initialValue = convertTextToHTML(initialValue);
            }
        } else if (contentType === 'Information verre du souvenir') {
            initialValue = fprDataContentSaved?.['form-modalInfoDrink'] || getDefaultValue('Information verre du souvenir');
            if (initialValue && !initialValue.includes('<p>')) {
                initialValue = convertTextToHTML(initialValue);
            }
        } else if (contentType === 'Adresse de correspondance') {
            initialValue = fprDataContentSaved?.['form-modalAdressCorres'] || getDefaultValue('Adresse de correspondance');
            if (initialValue && !initialValue.includes('<p>')) {
                initialValue = convertTextToHTML(initialValue);
            }
        } else if (contentType === 'Formule de remerciement') {
            initialValue = fprDataContentSaved?.['form-modalIntro'] || '';
        }

        setValues({ content: initialValue });
    }, [fprDataContentSaved, contentType, deceasedInfos, deceasedEventInfos, eventList])

    useEffect(() => {
        apiFprDecesContentList()
        apiIntroductionTextList()
        apiRemerciementTextList()
    }, [type, contentType]);


    const handleChange = (e) => {
        const { value } = e.target;

        if (contentType === 'Intervenants') {
            setSelectedIntervenantText(value);

            const htmlContent = convertTextToHTML(value);

            setValues(prev => ({ ...prev, content: htmlContent }));
            setRenderKey(prev => prev + 1);
            return;
        }

        const htmlContent = convertTextToHTML(value);

        if (selectedFormule !== value) {
            setValues(prev => ({ ...prev, content: htmlContent }))
            setSelectedFormule(value)
            setRenderKey(prev => prev + 1);
            return
        }

        setValues(prev => ({ ...prev, content: htmlContent }))
        setRenderKey(prev => prev + 1);
    }

    const parseContentToLines = (html) => {
        if (!html) return ["", "", ""];
        let lines = html.split("<br/>");
        if (lines.length === 1) {
            let tmp = html.replace(/<\/p><p>/gi, "<br/>")
                .replace(/<p>/gi, "")
                .replace(/<\/p>/gi, "");
            lines = tmp.split("<br/>");
        }
        while (lines.length < 3) lines.push("");
        return lines;
    }

    const handleChangeFirst = (e) => {
        const val = e.target.value;
        const lines = parseContentToLines(values?.content);
        lines[0] = val;
        setValues(prev => ({ ...prev, content: linesToHTML(lines) }));
        setRenderKey(prev => prev + 1);
    }

    const handleChangeFirstOther = (e) => {
        const val = e.target.value;
        const lines = parseContentToLines(values?.content);
        let firstLine = lines[0] || "";
        let firstLineParts = firstLine.split(" - ");
        firstLineParts[1] = val;
        while (firstLineParts.length < 2) firstLineParts.push("");
        lines[0] = firstLineParts.join(" - ");
        setValues(prev => ({ ...prev, content: linesToHTML(lines) }));
        setRenderKey(prev => prev + 1);
    }

    const handleChangeSecond = (e) => {
        const val = e.target.value;
        const lines = parseContentToLines(values?.content);
        let lineIndex = 1;
        if (eventList?.length > 0) {
            const hasCivilCeremonyDropdown = eventList?.filter(event => (event?.typeKey === "Ceremonie") && ![1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 &&
                eventList?.filter(event => (event?.typeKey === "Ceremonie") && [1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0;
            if (!hasCivilCeremonyDropdown) lineIndex = 1;
            lines[lineIndex] = val;
            while (lines.length <= lineIndex) lines.push("");
            setValues(prev => ({ ...prev, content: linesToHTML(lines) }));
            setRenderKey(prev => prev + 1);
        }
    }

    const handleChangeThird = (e) => {
        const val = e.target.value;
        const lines = parseContentToLines(values?.content);
        let lineIndex = 2;
        if (eventList?.length > 0) {
            const hasCivilCeremonyDropdown = eventList?.filter(event => (event?.typeKey === "Ceremonie") && ![1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 &&
                eventList?.filter(event => (event?.typeKey === "Ceremonie") && [1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0;
            const hasCremationDropdown = eventList?.some(event => event?.typeKey === "Cremation");
            if (!hasCivilCeremonyDropdown && !hasCremationDropdown) {
                lineIndex = 1;
            } else {
                lineIndex = 2;
            }
            lines[lineIndex] = val;
            while (lines.length <= lineIndex) lines.push("");
            setValues(prev => ({ ...prev, content: linesToHTML(lines) }));
            setRenderKey(prev => prev + 1);
        }
    }

    const handleFilterKeyword = () => {
        let value = symboleInputRef?.current?.value || "";
        if (value.length > 2) {
            if (contentType === "Symboles") {
                setFprFilteredList(
                    fprSymbolList?.filter(item =>
                        item['keyword']?.toLowerCase().includes(value.toLowerCase()) ||
                        item['url']?.toLowerCase().includes(value.toLowerCase())
                    )
                );
            } else {
                const filtered = fprDecesContentList?.filter(item =>
                    item['keyword']?.some(keyword =>
                        keyword.toLowerCase().includes(value.toLowerCase())
                    )
                );
                setFprFilteredList(processEquivalences(filtered));
            }
        } else {
            if (contentType === "Symboles") {
                setFprFilteredList(fprSymbolList);
            } else {
                setFprFilteredList([]);
            }
        }
    }

    const handleFilterEpitapheKeyword = () => {
        let value = epitapheInputRef?.current?.value || "";
        setIsInitialLoad(false);
        if (value.length > 2) {
            setFilteredKeywordList(keywordList?.filter(keyword => keyword.toLowerCase().includes(value.toLowerCase())))
        } else {
            setFilteredKeywordList(null)
        }
    }

    useEffect(() => {
        if (filteredKeywordList && filteredKeywordList.length > 0) {
            const filtered = fprDecesContentList?.filter(item =>
                item['keyword']?.some(keyword =>
                    keyword.toLowerCase().includes(filteredKeywordList[0].toLowerCase())
                )
            );
            setFprFilteredList(processEquivalences(filtered));
        }
    }, [filteredKeywordList, fprDecesContentList, contentType]);

    const contentLines = useMemo(() => {
        return parseContentToLines(values?.content);
    }, [values?.content]);


    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                <legend>{contentType}</legend>
                {contentType === 'Epitaphes' &&
                    <>
                        <div className="form-input">
                            <label>Recherche d'un mot-clef</label>
                            <input ref={epitapheInputRef} type="text" onKeyUp={handleFilterEpitapheKeyword} placeholder="Recherche par mot-clef..." />
                        </div>
                        <div className="form-input">
                            <label>Filtrer par mot-clef</label>
                            <select onChange={onChangeKeyword} value={keyword || "default"}>
                                <option value="default">Tous les mots clés</option>
                                {(filteredKeywordList || keywordList)?.map((keyword, index) => {
                                    return <option key={index} value={keyword}>{keyword}</option>
                                })}
                            </select>
                        </div>
                            <h4>Exemples :</h4>
                            <div className="listTextExemple">
                                {fprFilteredList?.map((item) => {
                                    return (
                                        <div
                                            key={item['id']}
                                            className={`textExemple ${item['text'] === selectedFormule ? 'selected' : ''}`}
                                            onClick={() => {
                                                setValues({...values, content: item['text']});
                                                setSelectedFormule(item['text']);
                                                onChange(item['text']);
                                            }}
                                        >
                                            {item['text']}
                                        </div>
                                    );
                                })}
                            </div>
                        <div className="form-input html-textarea view">
                            <h4>Résultat :</h4>
                            <label htmlFor="content">Choix d'une épitaphe</label>
                            <TiptapForm key={renderKey} content={selectedFormule ? selectedFormule : values?.content || ""} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Symboles' &&
                    <>
                        <div className="form-input">
                            <label>Recherche d'un mot-clef</label>
                            <input ref={symboleInputRef} type="text" onKeyUp={handleFilterKeyword} placeholder="Recherche par mot-clef..." />
                        </div>
                        <div className="form-input">
                            <label>Filtrer par mot-clef</label>
                            <select onChange={onChangeKeyword} value={keyword || "default"}>
                                <option value="default" disabled="disabled">Tous les mots clés</option>
                                {keywordList?.map((keyword, index) => {
                                    return <option key={index} value={keyword}>{keyword}</option>
                                })}
                            </select>
                        </div>
                        <div className="images-div fpr flex">
                            {fprFilteredList?.map((symbol, index) => {
                                const isSelected = values?.content === symbol?.['url'] || (values?.content && values.content.endsWith('/' + symbol?.['url']));
                                return (
                                    <div key={index} onClick={() => onChangeSymbol(symbol['url'])} className={`image ${isSelected ? 'selected' : ''}`}>
                                        {isSelected && <i className="fa fa-check"></i>}
                                        <div
                                            style={{ backgroundImage: `url(${IMG_FOLDER}/img/fpr/symboles-miniature/${symbol?.['url']})` }}
                                            className='portrait'
                                        >
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </>
                }
                {contentType === 'Intervenants' &&
                    <>
                        <div className="form-input">
                            <select name="content" value={selectedIntervenantText || "default"} onChange={handleChange}>
                                <option value="default" disabled="disabled">Toutes les formules</option>
                                {fprIntervenantList?.map((item) => {
                                    return <option key={item['id']} value={item['text']}>{item['name']}</option>
                                })}
                            </select>
                        </div>
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Choix des intervenants</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Formule d\'introduction' &&
                    <>
                        <div className="form-input">
                            <select name="content" value={values?.content || "default"} onChange={handleChange}>
                                <option value="default" disabled="disabled">Toutes les formules</option>
                                {fprIntroductionList?.map((item) => {
                                    return <option key={item['id']} value={item['formules']}>{item['text']}</option>
                                })}
                            </select>
                        </div>
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Formule d'introduction</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Information décès' &&
                    <>
                        <div className="form-input">
                            <select name="content" value={values?.content || "default"} onChange={handleChange}>
                                <option value="default" disabled="disabled">Toutes les formules</option>
                                {fprInfosDecesList?.map((item) => {
                                    const adaptedText = adaptGenderText(item['text']);
                                    return <option key={item['id']} value={adaptedText}>{adaptedText}</option>
                                })}
                            </select>
                        </div>
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Informations sur le décès</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Formule de remerciement' &&
                    <>
                            <h4>Exemples :</h4>
                            <div className="listTextExemple">
                                {fprRemerciementList?.map((item) => {
                                    return (
                                        <div
                                            key={item['id']}
                                            className="textExemple"
                                            onClick={() => {
                                                setValues({...values, content: item['text']});
                                                onChange(item['text']);
                                            }}
                                        >
                                            {item['text']}
                                        </div>
                                    );
                                })}
                            </div>
                        <div className="form-input html-textarea view">
                            <h4>Résultat :</h4>
                            <label htmlFor="content">Formule de remerciement</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Information cérémonie' &&
                    <>
                        <div className="form-input">
                            {eventList?.some(event => event?.typeKey === "Ceremonie") && (
                                <select name="content" value={contentLines[0] || "default"} onChange={handleChangeFirst}>
                                    <option value="default" disabled>Toutes les formules</option>
                                    {eventList?.filter(event => event?.typeKey === "Ceremonie" && [1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 ? (
                                        <>
                                            <option value={`Ses obsèques religieuses seront célébrées le ${deceasedEventInfos?.ceremonyDateNotFormatted}, à ${deceasedEventInfos?.ceremonyTime} ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                                Ses obsèques religieuses seront célébrées le {deceasedEventInfos?.ceremonyDateNotFormatted}, à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                            </option>
                                            <option value={`La cérémonie religieuse aura lieu le ${deceasedEventInfos?.ceremonyDateNotFormatted}, à ${deceasedEventInfos?.ceremonyTime} ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                                La cérémonie religieuse aura lieu le {deceasedEventInfos?.ceremonyDateNotFormatted}, à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                            </option>
                                            <option value={`Vous êtes priés de vous unir dans la prière lors de la messe de funérailles qui aura lieu le ${deceasedEventInfos?.ceremonyDateNotFormatted}, à ${deceasedEventInfos?.ceremonyTime} ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                                Vous êtes priés de vous unir dans la prière lors de la messe de funérailles qui aura lieu le {deceasedEventInfos?.ceremonyDateNotFormatted}, à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                            </option>
                                        </>
                                    )
                                        :
                                        eventList?.filter(event => (event?.typeKey === "Ceremonie") && ![1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 ? (
                                            <>
                                                <option value={`Un hommage civil lui sera rendu le ${deceasedEventInfos?.ceremonyDateNotFormatted}, à ${deceasedEventInfos?.ceremonyTime} ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                                    Un hommage civil lui sera rendu le {deceasedEventInfos?.ceremonyDateNotFormatted}, à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                                </option>
                                                <option value={`La cérémonie civile aura lieu le ${deceasedEventInfos?.ceremonyDateNotFormatted} à ${deceasedEventInfos?.ceremonyTime}, ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                                    La cérémonie civile aura lieu le {deceasedEventInfos?.ceremonyDateNotFormatted} à {deceasedEventInfos?.ceremonyTime}, {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                                </option>
                                            </>) : ""}
                                    <>
                                        <option value={`Ses funérailles auront lieu le ${deceasedEventInfos?.ceremonyDateNotFormatted}, à ${deceasedEventInfos?.ceremonyTime} ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>
                                            Ses funérailles auront lieu le {deceasedEventInfos?.ceremonyDateNotFormatted}, à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}
                                        </option>
                                        <option value="Pour la cérémonie funéraire, la famille souhaite rester dans l'intimité familiale.">
                                            Pour la cérémonie funéraire, la famille souhaite rester dans l'intimité familiale.
                                        </option>
                                    </>
                                </select>
                            )}
                        </div>
                        {eventList?.filter(event => (event?.typeKey === "Ceremonie") && ![1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 &&
                            eventList?.filter(event => (event?.typeKey === "Ceremonie") && [1, 2, 3, 4, 5].includes(event?.placeTypeKey)).length > 0 && (
                                <div className="form-input">
                                    <select name="content" value={contentLines[1] || "default"} onChange={handleChangeFirstOther}>
                                        <option value="default" disabled>Choix d'une formule pour la crémation</option>
                                        <option value={`Suivie(s) d'une cérémonie civile à ${deceasedEventInfos?.ceremonyTime} à ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>Suivie(s) d'une cérémonie civile à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}</option>
                                        <option value={`La cérémonie civile aura lieu à ${deceasedEventInfos?.ceremonyTime} à ${replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}`}>La cérémonie civile aura lieu à {deceasedEventInfos?.ceremonyTime} {replaceHomeAddress(deceasedEventInfos?.ceremonyPlace)}</option>
                                    </select>
                                </div>
                            )}
                        {(eventList?.some(event => event?.typeKey === "Cremation")) &&
                            <div className="form-input">
                                <select name="content" value={contentLines[1] || "default"} onChange={handleChangeSecond}>
                                    <option value="default" disabled>Choix d'une formule pour la crémation</option>
                                    <option value={`Suivie(s) de la crémation à ${deceasedEventInfos?.cremationTime}, ${replaceHomeAddress(deceasedEventInfos?.cremationPlace)}`}>Suivie(s) de la crémation à {deceasedEventInfos?.cremationTime}, {replaceHomeAddress(deceasedEventInfos?.cremationPlace)}</option>
                                    <option value={`La cérémonie sera suivie de la crémation qui aura lieu à ${deceasedEventInfos?.cremationTime}, ${replaceHomeAddress(deceasedEventInfos?.cremationPlace)}`}>La cérémonie sera suivie de la crémation qui aura lieu à {deceasedEventInfos?.cremationTime}, {replaceHomeAddress(deceasedEventInfos?.cremationPlace)}</option>
                                </select>
                            </div>
                        }
                        {(eventList?.some(event => event?.typeKey === "Obseques")) &&
                            <div className="form-input">
                                <select name="content" value={contentLines[2] || "default"} onChange={handleChangeThird}>
                                    <option value="default" disabled>Choix d'une formule pour l'inhumation</option>
                                    <option value={`Suivie(s) de l'inhumation à ${deceasedEventInfos?.obsequesTime}, à ${replaceHomeAddress(deceasedEventInfos?.obsequesPlace)}`}>Suivie(s) de l'inhumation à {deceasedEventInfos?.obsequesTime}, {replaceHomeAddress(deceasedEventInfos?.obsequesPlace)}</option>
                                    <option value={`La cérémonie sera suivie de l'inhumation qui aura lieu à ${deceasedEventInfos?.obsequesTime}, ${replaceHomeAddress(deceasedEventInfos?.obsequesPlace)}`}>La cérémonie sera suivie de l'inhumation qui aura lieu à {deceasedEventInfos?.obsequesTime}, {replaceHomeAddress(deceasedEventInfos?.obsequesPlace)}</option>
                                </select>
                            </div>
                        }
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Informations sur la cérémonie</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Information recueillement' &&
                    <>
                        {eventList?.some(event => event?.typeKey === "Recueillement") && (
                            <div className="form-input">
                                <select name="content" value={values?.content || "default"} onChange={handleChange}>
                                    <option value="default" disabled>Toutes les formules</option>
                                    {deceasedInfos?.firstName && <option value={`${deceasedInfos?.firstName} repose ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}>{`${deceasedInfos?.firstName} repose ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}</option>}
                                    {(deceasedInfos?.firstName && deceasedInfos?.lastName) && <option value={`${deceasedInfos?.firstName} ${deceasedInfos?.lastName} repose ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}>{`${deceasedInfos?.firstName} ${deceasedInfos?.lastName} repose ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}</option>}
                                    {deceasedInfos?.firstName && <option value={`Vous pouvez venir vous recueillir auprès de ${deceasedInfos?.firstName} ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}>{`Vous pouvez venir vous recueillir auprès de ${deceasedInfos?.firstName} ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}</option>}
                                    {(deceasedInfos?.firstName && deceasedInfos?.lastName) && <option value={`Vous pouvez venir vous recueillir auprès de ${deceasedInfos?.firstName} ${deceasedInfos?.lastName} ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}>{`Vous pouvez venir vous recueillir auprès de ${deceasedInfos?.firstName} ${deceasedInfos?.lastName} ` + replaceHomeRecAddress(deceasedEventInfos?.recueillementPlace) + `.`}</option>}
                                </select>
                            </div>
                        )}
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Informations sur le recueillement</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Information verre du souvenir' &&
                    <>
                        {eventList?.some(event => event?.typeKey === "VinHonneur") && (
                            <div className="form-input">
                                <select name="content" value={values?.content || "default"} onChange={handleChange}>
                                    <option value="default" disabled>Toutes les formules</option>
                                    <option value={`Au domicile du défunt : un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} est organisé à ${deceasedEventInfos?.vinHonneurTime}.`}>{`Au domicile du défunt : un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} est organisé à ${deceasedEventInfos?.vinHonneurTime}.`}</option>
                                    {(deceasedInfos?.firstName && deceasedInfos?.lastName) && <option value={`Chez ${deceasedInfos?.hiddenCivility ? '' : (deceasedInfos?.civility ? deceasedInfos.civility + ' ' : '')}${deceasedInfos?.firstName} ${deceasedInfos?.lastName} : Un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} est organisé à ${deceasedEventInfos?.vinHonneurTime}.`}>{`Chez ${deceasedInfos?.hiddenCivility ? '' : (deceasedInfos?.civility ? deceasedInfos.civility + ' ' : '')}${deceasedInfos?.firstName} ${deceasedInfos?.lastName} : Un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} est organisé à ${deceasedEventInfos?.vinHonneurTime}.`}</option>}
                                    <option value={`Au domicile du défunt : Nous nous réunirons tous ensemble autour d'un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} à ${deceasedEventInfos?.vinHonneurTime}.`}>{`Au domicile du défunt : Nous nous réunirons tous ensemble autour d'un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} à ${deceasedEventInfos?.vinHonneurTime}.`}</option>
                                    {(deceasedInfos?.firstName && deceasedInfos?.lastName) && <option value={`Chez ${deceasedInfos?.hiddenCivility ? '' : (deceasedInfos?.civility ? deceasedInfos.civility + ' ' : '')}${deceasedInfos?.firstName} ${deceasedInfos?.lastName} : Nous nous réunirons tous ensemble autour d'un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} à ${deceasedEventInfos?.vinHonneurTime}.`}>{`Chez ${deceasedInfos?.hiddenCivility ? '' : (deceasedInfos?.civility ? deceasedInfos.civility + ' ' : '')}${deceasedInfos?.firstName} ${deceasedInfos?.lastName} : Nous nous réunirons tous ensemble autour d'un ${deceasedEventInfos?.vinHonneurType ? "repas funéraire" : "verre du Souvenir"} à ${deceasedEventInfos?.vinHonneurTime}.`}</option>}
                                </select>
                            </div>
                        )}
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Informations sur le verre du souvenir</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                {contentType === 'Adresse de correspondance' &&
                    <>
                        <div className="form-input">
                            <select name="content" value={values?.content || "default"} onChange={handleChange}>
                                <option value="default" disabled>Toutes les formules</option>
                                {deceasedInfos?.conjointInfos && <option value={formatAddress(deceasedInfos?.conjointInfos)}>{formatAddress(deceasedInfos?.conjointInfos)}</option>}
                                {deceasedInfos?.gestionnaireInfos && deceasedInfos?.isConjointAdmin === false && <option value={formatAddress(deceasedInfos?.gestionnaireInfos)}>{formatAddress(deceasedInfos?.gestionnaireInfos)}</option>}
                                {deceasedInfos?.agencyInfos && <option value={formatAddress(deceasedInfos?.agencyInfos)}>{formatAddress(deceasedInfos?.agencyInfos)}</option>}
                                {deceasedInfos?.conjointInfos && deceasedInfos?.agencyInfos && <option value={`${formatAddress(deceasedInfos?.conjointInfos)}<br/>${formatAddress(deceasedInfos?.agencyInfos)}`}>{`${formatAddress(deceasedInfos?.conjointInfos)} ${formatAddress(deceasedInfos?.agencyInfos)}`}</option>}
                                {deceasedInfos?.gestionnaireInfos && deceasedInfos?.isConjointAdmin === false && deceasedInfos?.agencyInfos && <option value={`${formatAddress(deceasedInfos?.gestionnaireInfos)}<br/>${formatAddress(deceasedInfos?.agencyInfos)}`}>{`${formatAddress(deceasedInfos?.gestionnaireInfos)} ${formatAddress(deceasedInfos?.agencyInfos)}`}</option>}
                            </select>
                        </div>
                        <div className="form-input html-textarea view">
                            <label htmlFor="content">Informations sur la cérémonie</label>
                            <TiptapForm key={renderKey} content={values?.content} onChange={onChange} />
                        </div>
                    </>
                }
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleSubmit={handleSubmit} handleRemoveModal={handleRemoveModal} />
        </form>
    )
}
